import { createSelector } from 'reselect'

export const selectCalendar = state => {
  return state?.calendar
}
export const selectCalendarOptions = state => {
  return state.calendar.options || []
}

export const getCalendarError = createSelector(
  selectCalendar,
  data => {
    const generalError = data?.error
    if (generalError) {
      return generalError
    }
    const HrError = data?.types?.hr?.error
    if (HrError) {
      return HrError
    }
    const ClaimError = data?.types?.claim?.error
    if (ClaimError) {
      return ClaimError
    }
    const CaseError = data?.types?.case?.error
    if (CaseError) {
      return CaseError
    }
  }
)

export const getCalendarLoading = createSelector(
  selectCalendar,
  data => data.isLoading,
)